import { hot } from 'react-hot-loader';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import welcomeLineImg from '../assets/images/welcome-line.svg';
import own1Img from '../assets/images/own/1.png';
import own1X2Img from '../assets/images/own/1@2x.png';
import own2Img from '../assets/images/own/2.png';
import own2X2Img from '../assets/images/own/2@2x.png';

import './ScreenWelcome.scss';



function ScreenWelcome() {
  const isMobile = useMediaPredicate(mobileBreakpoint);

  return (
    <section className="section-welcome">
      <br />
      <div className="container" data-aos="fade-up">
        {!isMobile && <div className="welcome-line"
          data-aos="fade-down" data-delay="500" data-offset="100"
        >
          {/*<img
            width="816" height="172" alt="" title="" className=""
            src={welcomeLineImg}
          />*/}
        </div>}

        <div className="row align-items-center row-mb-144" data-aos="fade-right">
          <div className="col-lg-8">
            <div className="welcome__img">
              <img
                alt="" title="" className="img-responsive"
                src={own1Img} srcSet={`${own1X2Img} 2x`}
              />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="pre-title"><span>Welcome to Marvin’s Pet Shop</span></div>
            <h2 className="title">The Story Behind <span>Roborovski</span> the Hamster</h2>
            <p className="desc">Left alone and forgotten, Roborovski’s size keeps him isolated from the hustle and bustle of Marvin’s Pet Shop. Resentment and jealousy begin to pour into his body, where he will storm the world in a murderous rampage.</p>
          </div>
        </div>

        {/*<div className="row align-items-center" data-aos="fade-left">
          <div className="col-lg-4 order-2 order-lg-1">
            <div className="pre-title"><span>Become Part of This Monumental Tale</span></div>
            <h2 className="title">intricately crafted by a team of <span>award-winning</span> Hollywood artists</h2>
            <p className="desc">Caravan Studio has lovingly made the NFT artwork collection that narrates his story, paired with an exclusive film for owners. One of the most revered names in comic books, video games, film, and media art.</p>
          </div>
          <div className="col-lg-8 order-1 order-lg-2">
            <div className="welcome__img welcome__img--right">
              <img
                alt="" title="" className="img-responsive"
                src={own2Img} srcSet={`${own2X2Img} 2x`}
              />
            </div>
          </div>
        </div>*/}
      </div>
    </section>
  );
};

export default hot(module)(ScreenWelcome);
